import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { SharedModule } from './shared/shared.module';
import { LoadService } from './shared/components/loading/loading.service';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ToastService } from './shared/components/toast/toast.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AlertModalComponent } from './shared/components/alert-modal/alert-modal.component';
import { environment } from '../environments/environment';
import { UserServiceApi } from './api/service/user.service';
import { RiskService } from './pages/dashboard/pages/risk-mapping/risk-management/risk.service';
  
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, CommonModule, ToastComponent],
  providers: [LoadService, ToastService, UserServiceApi, RiskService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  
  isLoading:boolean = false;

  constructor(private loadService: LoadService) {}

  ngOnInit(): void {
    this.loadService.getLoadingStatus()
    .subscribe((status) =>  {
      this.isLoading = status}
    )
  }

}
